import { Button, IconButton, Stack, Tooltip } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { CloseOMIcon, FilterOMIcon } from '@omnea-app/icons'
import { useFilterPanelToggle } from '../../data-grid/hooks/useFilterPanelToggle'

type Props = {
  filteredColumnNames: string[] | null
  disabled: boolean
  onClearFilters: () => void
}

export const ToolbarFiltersButton = ({ filteredColumnNames, disabled, onClearFilters }: Props) => {
  const { t } = useTranslation('common')
  const { isFilterButtonShown, filterButtonProps } = useFilterPanelToggle()

  if (!isFilterButtonShown) return null

  return (
    <Stack direction="row" alignItems="center">
      <Tooltip title={t('table.table-toolbar.tooltip-filter')} describeChild>
        <Button
          {...filterButtonProps}
          className={filteredColumnNames ? 'active' : undefined}
          color="secondary"
          variant="text"
          size="small"
          disabled={disabled}
          startIcon={<FilterOMIcon />}
        >
          {filteredColumnNames
            ? t('table.table-toolbar.active-filter-button-label', { columnList: filteredColumnNames.join(', ') })
            : t('table.table-toolbar.empty-filter-button-label')}
        </Button>
      </Tooltip>
      {filteredColumnNames && (
        <IconButton size="small" aria-label={t('dialog.clear')} disabled={disabled} onClick={onClearFilters}>
          <CloseOMIcon />
        </IconButton>
      )}
    </Stack>
  )
}
